import { render, staticRenderFns } from "./siteComponent.vue?vue&type=template&id=39cf5638&scoped=true&"
import script from "./siteComponent.vue?vue&type=script&lang=js&"
export * from "./siteComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cf5638",
  null
  
)

export default component.exports